<template>
    <div
        class="step step-1 flex flex-col items-center w-full top-0 bottom-0"
    >
        <h2 class="subtitle white text-center mt-5">
            {{ $trans.get("deposits.step-1-subtitle") }}
        </h2>
        <div
            class="flex flex-col justify-center space-y-8 lg:flex-row lg:space-x-20 lg:space-y-0 xl:space-x-40"
        >
            <div class="flex flex-col items-start">
                <p class="title-type font-bold mb-8">
                    {{ $trans.get("deposits.permits") }}
                </p>
                <div
                    v-for="{ id, name, description } in permits"
                    class="input inline-flex cursor-pointer"
                    :class="{ selected: isSelected('permit', id) }"
                    :key="id"
                    @click="set('permit', id)"
                >
                    <span class="circle mr-3 flex justify-center items-center">
                        <div class="inner"></div>
                    </span>
                    <span class="font-bold"
                        >{{ name[lang] }} {{ description[lang] }}</span
                    >
                </div>
            </div>
            <div class="flex flex-col items-start">
                <p class="title-type font-bold mb-8">
                    {{ $trans.get("deposits.courses") }}
                </p>
                <div
                    v-for="{ id, name, description } in courses"
                    class="input inline-flex cursor-pointer"
                    :class="{ selected: isSelected('course', id) }"
                    :key="id"
                    @click="set('course', id)"
                >
                    <span class="circle mr-3 flex justify-center items-center">
                        <div class="inner"></div>
                    </span>
                    <span class="font-bold"
                        >{{ name[lang] }} {{ description[lang] }}</span
                    >
                </div>
            </div>
        </div>
        <button
            class="mdc-button mdc-button--unelevated mdc-ripple-upgraded unelevated flex justify-between items-center mt-5"
            :disabled="! titleType"
            @click="$emit('update:current-step', 2)"
        >
            <span class="mdc-button__label -mr-1 ml-6">{{
                $trans.get("deposits.next")
            }}</span>
            <span class="material-icons">keyboard_arrow_right</span>
        </button>
    </div>
</template>

<script>
import { mapGetters, mapMutations } from "vuex";

export default {
    props: {
        permits: {
            type: Array
        },
        courses: {
            type: Array
        }
    },

    data() {
        return {
            lang: window.appLocale,
        };
    },

    computed: {
        ...mapGetters(["getFormData"]),
        titleType() {
            return this.getFormData.titleType;
        },
        titleId() {
            return this.getFormData.titleId;
        }
    },

    methods: {
        ...mapMutations(["setParamFromFormData"]),
        set(titleType, titleId) {
            this.$store.commit("setParamFromFormData", {
                param: "titleType",
                value: titleType
            });
            this.$store.commit("setParamFromFormData", {
                param: "titleId",
                value: titleId
            });
        },
        isSelected(titleType, titleId) {
            return (
                this.getFormData.titleType === titleType &&
                this.getFormData.titleId === titleId
            );
        }
    }
};
</script>

<style scoped lang="scss">
@import "../../../sass/_variables.scss";

.title-type {
    font-size: 20px;
    opacity: 0.6;
}
</style>
